import Image from 'next/image';

import { Section, SectionHeader } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/helpers/screenResolutionHelper';

const aiEngineData = [
  {
    icon: 'mind.svg',
    alt: 'Mind Icon',
    title: 'Mind',
    subtitle: 'Your intelligent co-creator.',
    description:
      'Our domain-trained AI understands the language of events (capacities, stage sizes, décor styles, dietary needs, AV specs, logistics) and the trade-offs between time, budget, and quality. It moves from vague ideas to detailed plans in minutes, not days.'
  },
  {
    icon: 'memory.svg',
    alt: 'Memory Icon',
    title: 'Memory',
    subtitle: 'A living knowledge graph.',
    description:
      'Proprietary dataset built on 80,000+ event briefs, including 20,000+ delivered events. Every brief, quote, venue layout, supplier interaction, and feedback loop improves the next recommendation—creating a defensible data moat.'
  },
  {
    icon: 'muscle.svg',
    alt: 'Muscle Icon',
    title: 'Muscle',
    subtitle: 'The on-ground execution engine.',
    description:
      "The UAE's largest event service supply network. Once a plan is set, our platform orchestrates sourcing, negotiations, schedules, and logistics with speed and accountability—so the show runs flawlessly."
  }
];

const VerticalAIEngine = () => {
  const [isMobile] = useIsMobile();
  return (
    <>
      <Section>
        <SectionHeader
          description='Mind · Memory · Muscle'
          gradientText='AI Engine'
          text='The Vertical'
        />
        <div className='grid grid-cols-1 gap-6 md:grid-cols-3 mb-8 font-Montserrat'>
          {aiEngineData.map((card, index) => (
            <div
              key={index}
              className='bg-white rounded-xl shadow-md p-4 md:p-8 flex flex-col border border-pink-100 hover:border-pink-200 hover:shadow-xl transition-all duration-300'
            >
              <div className='mb-4'>
                <Image
                  alt={card.alt}
                  height={isMobile ? 64 : 80}
                  width={isMobile ? 64 : 80}
                  src={`${staticMediaStoreBaseURL}/about-hafla/vertical-ai-engine/${card.icon}`}
                  style={{
                    width: isMobile ? '64px' : '80px',
                    height: isMobile ? '64px' : '80px',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <div className='text-2xl md:text-3xl font-extrabold bg-control bg-clip-text text-transparent mb-2 text-stroke-thin md:text-stroke-normal'>
                {card.title}
              </div>
              <div className='font-semibold mb-2'>{card.subtitle}</div>
              <div className='text-gray-600 text-base'>{card.description}</div>
            </div>
          ))}
        </div>
        <div className='text-center text-base md:text-lg text-gray-800 font-medium'>
          Together,{' '}
          <span className='bg-control bg-clip-text text-transparent text-stroke-thin md:text-stroke-normal'>
            Mind-Memory-Muscle
          </span>{' '}
          is a closed-loop system where intelligence, data, and execution work
          in perfect synergy.
        </div>
      </Section>
      <div className='border-t border-pink-100 container mx-auto' />
    </>
  );
};

export default VerticalAIEngine;
